export const heroSliderInit = () => {
  if(document.querySelector('.hero-slider')) {
    const heroSliders = document.querySelectorAll('.hero-slider__content');
  
    if(heroSliders) {
      heroSliders.forEach((item) => {
        const heroSlider = new window.splide(item, {
          perPage: 1,
          perMove: 1,
          type: 'fade',
          pagination: false,
          autoplay: true,
          rewind: true
        });
  
        heroSlider.mount();
      });
    }
  }
}